/* eslint-disable @typescript-eslint/no-empty-interface */

import React from 'react';
import classnames from 'classnames';
import { getImg } from '@home/_config/getImgs';
import AspectRatioBox from '@gp/components/AspectRatioBox';
import { DPS_REPORT_STYLE_CFG } from '../../constants';

import type { IBaseProps } from '@home/types/common';

import GameIcon from '@gp/assets/svg/weekly-report/icon-game.svg';

interface IReportWallpaperHeaderProps extends IBaseProps {
  dateTitle?: string;
}

const LogoIcon = getImg('logo');

const ReportWallpaperHeader: React.FC<IReportWallpaperHeaderProps> = (props) => {
  const { style, className, dateTitle } = props;

  return (
    <AspectRatioBox
      className="dbg-dps-report-wallpaper-aspect-ratio-box"
      width={DPS_REPORT_STYLE_CFG.POSTER_WIDTH}
      height={DPS_REPORT_STYLE_CFG.POSTER_HEIGHT}
    >
      <header style={style} className={classnames('dbg-dps-report-wallpaper-header', className)}>
        <div className="dbg-dps-report-wallpaper-header__logo-box">
          <img src={LogoIcon} />
        </div>
        <div
          style={{
            top: `${(DPS_REPORT_STYLE_CFG.POSTER_DESC_BOX_TOP / DPS_REPORT_STYLE_CFG.POSTER_HEIGHT) * 100}%`,
          }}
          className="dbg-dps-report-wallpaper-header__summary-box"
        >
          <p className="dbg-flex-center">
            <img className="dbg-dps-report-wallpaper-header__summary-icon" src={GameIcon} />
            <span>GPOP Newsletter</span>
          </p>
          <p>{dateTitle}</p>
        </div>
      </header>
    </AspectRatioBox>
  );
};

export default ReportWallpaperHeader;
